import { render, staticRenderFns } from "./Bizziice.vue?vue&type=template&id=25152bea&scoped=true&"
import script from "./Bizziice.vue?vue&type=script&lang=js&"
export * from "./Bizziice.vue?vue&type=script&lang=js&"
import style0 from "./Bizziice.vue?vue&type=style&index=0&id=25152bea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25152bea",
  null
  
)

export default component.exports